import { camposEnderecoStore } from '../../../../stateManagement/camposEndereco';

/**
 * Modelo de objeto para endereço;
 * @class Endereco
 * @namespace Endereco
 */
export default class Endereco {
  /**
   * Modelo do objeto de endereço
   * @param {String} cep - CEP
   * @param {String} endereco - Logradouro
   * @param {Number | null} numero - Número
   * @param {String} complemento - Complemento
   * @param {String} bairro - Bairro
   * @param {String} cidade - Cidade
   * @param {String} estado - Estado
   * @param {String} pais - País
   * @param {Boolean} semNumero - Sem número
   */
  constructor(cep = '', endereco = '', numero = null, complemento = '', bairro = '', cidade = '', estado = '', pais = '', semNumero = false) {
    this.cep = cep;
    this.endereco = endereco;
    this.numero = numero;
    this.complemento = complemento;
    this.bairro = bairro;
    this.cidade = cidade;
    this.estado = estado;
    this.pais = pais;
    this.semNumero = semNumero;
  }

  /**
   * Atualiza modelo com dados válidos de um objeto com dados de
   * formulário;
   * @param {Object} formData Objeto com dados do formulário
   */
  updateDados(formData) {
    for (let propriedade in formData) {
      if (!Object.keys(formData).includes(propriedade)) {
        console.warn(`WARN: Propriedade "${propriedade}" não é valido para modelo`);
        continue;
      }
      this[propriedade] = formData[propriedade];
    }
  }

  /**
   * Formata e trata, se necessário dados do modelo para ser inserido no body de um request
   * @returns {Object} Objeto formatado para body da requisição;
   */
  asRequestBody(cleanBody = true) {
    let body = {
      cep: this.cep != null ? this.cep.replace('-', '') : null,
      endereco: this.endereco,
      numero: this.semNumero ? "SN" : this.numero,
      complemento: this.complemento,
      bairro: this.bairro,
      cidade: this.cidade,
      estado: this.estado,
      pais: this.pais
    };

    if(cleanBody) {
      this.cleanBody(body);
    }

    return body;
  }

  /**
   * Limpa do objeto campos vazios antes de enviar o request para o back;
   * @param {Object} body - body do request
   */
  cleanBody(body) {
    for (const prop in body) {
      if (body[prop] === '' || body[prop] === null || (Array.isArray(body[prop]) && body[prop].length == 0)) {
        delete body[prop];
      }
    }
  }

  /**
   * Formata e trata, se necessário, dados da resposta para o modelo
   */
  asModel(response) {
    this.cep = response.cep;
    this.endereco = response.endereco;
    this.numero = response.numero != null && response.numero != "SN" ? response.numero.toString() : null;
    this.semNumero = response.numero == "SN";
    this.complemento = response.complemento;
    this.bairro = response.bairro;
    this.cidade = response.cidade;
    this.setEstado(response.estado);
    this.setPais(response.pais);
  }

  setEstado(estado) {
    const listagemUFs = camposEnderecoStore.estados;
    this.setFromResponse(listagemUFs, estado, 'estado');
  }

  setPais(pais) {
    const listagemPaises = camposEnderecoStore.paisesSigla;
    this.setFromResponse(listagemPaises, pais, 'pais');
  }

  /**
   * Encontra um valor em uma lista com base no dado da resposta.
   *
   * @param {Array<{label: string, value: any}>} lista A lista para pesquisar.
   * @param {string} dadoDaResponse O dado a ser pesquisado no objeto de resposta.
   * @param {string} propriedadeAlvo A propriedade do objeto 'this' para atribuir o valor encontrado.
   */
  setFromResponse(lista, dadoDaResponse, proprieadeAlvo) {
    if (!dadoDaResponse) return;

    const itemEncontrado = lista.find((item) => item.label === dadoDaResponse);
    if (!!itemEncontrado) {
      this[proprieadeAlvo] = itemEncontrado.value;
    }
  }
}
